import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CINTableRow = ({ loading, customers, path }) => {
  return (
    <tbody>
      {/* eslint-disable-next-line no-nested-ternary */}
      {loading ? (
        <tr className="py-3">
          <td colSpan={7}>
            <div className="d-flex justify-content-center w-100">
              <Spinner className="spinner" animation="border" variant="dark" />
            </div>
          </td>
        </tr>
      ) : customers && customers.length > 0 ? (
        customers.map((customer) => (
          <tr key={Math.random().toString(36).slice(-6)}>
            <td>
              {customer.lastname} {customer.firstname}
            </td>
            <td>{customer.phone}</td>
            <td>{customer.email}</td>
            <td>{customer.customer_type}</td>
            <td>
              <Link
                to={`${path}/${customer.customer_id}/${customer.firstname}/${customer.lastname}`}
                // onClick={() => setBackLink('/createcin')}
                className="w-100 btn customers_cin_table_button">
                Create CIN
              </Link>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={7} className="w-100 text-center">
            No Data
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default CINTableRow;
